import type {
  ApiBlobResource,
  ApiReturnResource,
} from '@highimpact-frontend/api-types';
import blobService from './ImageResourceService';
import type { ApiResource, IResourceService } from './IResourceService';
import textService from './TextResourceService';

class ResourceService
  implements IResourceService<ApiResource, ApiReturnResource>
{
  async add(params: ApiResource): Promise<ApiReturnResource> {
    if (params.resource_type === 'blob') {
      return await blobService.add(params);
    } else {
      return await textService.add(params);
    }
  }

  async update(
    resourceId: number,
    resource: Partial<ApiResource>
  ): Promise<ApiReturnResource> {
    if (resource.resource_type === 'blob') {
      return await blobService.update(resourceId, resource as ApiBlobResource);
    } else {
      return await textService.update(resourceId, resource as ApiBlobResource);
    }
  }

  async delete(resourceId: number): Promise<ApiReturnResource> {
    return await blobService.delete(resourceId);
  }

  async get(resourceIds: number[]): Promise<ApiReturnResource[]> {
    return await blobService.get(resourceIds);
  }

  async getByEntity(params: {
    project_id: number | null;
    site_id: number | null;
    device_id: number | null;
  }) {
    return await blobService.getByEntity(params);
  }
}

const resourceService = new ResourceService();
export default resourceService;
